<template>
  <div
    :class="$style.contextMenu"
    :style="{ left: mouseX + 'px', top: mouseY + 'px' }"
  >
    <router-link
      v-for="page in pages"
      :key="page.name"
      :class="$style.link"
      :to="{
        name: page.name,
        query: {
          dateFrom: eventRange.day.from,
          dateTo: eventRange.day.to,
          isWorktimeOnly,
          state: 2,
          selectedComputerId: userId,
          email,
        },
      }"
      target="_blank"
      @click.native="$emit('go')"
    >
      {{ page.text }}
    </router-link>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';

  dayjs.extend(utc);

  export default {
    props: ['userId', 'mouseX', 'mouseY', 'dateFrom', 'dateTo', 'isWorktimeOnly', 'pages', 'email'],

    computed: {
      eventRange() {
        return {
          day: {
            from: dayjs.utc(this.dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            to: dayjs.utc(this.dateTo).format('YYYY-MM-DD HH:mm:ss'),
          },
        };
      },
    },
  };
</script>

<style lang="scss" module>
  .contextMenu {
    box-shadow: 4px 6px 14px rgba(165, 165, 165, 0.4);
    position: fixed;
    background-color: white;
    padding: 10px;
    z-index: 10000;
  }

  .link {
    text-decoration: none;
    display: block;
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    &:hover {
      background: $borderColor;
    }
  }
</style>
